export default "__VITE_ASSET__9fbfa082__"